import { DATA_AUDIT_ACTIONS } from 'config';

export const initialState = {
  staticChartData: {
    data: [],
    loading: false,
    error: null
  },
  DataAuditDataType: 'relevant',
  staticBCBVData: {
    data: [],
    loading: false,
    error: null
  },
  npiDistributionMap: {
    data: [],
    loading: false,
    error: null
  },
  DrgByHospitalCountWithNtype: {
    data: [],
    loading: false,
    error: null
  },
  HospitalCountByDRG: {
    data: [],
    loading: false,
    error: null
  },
  DistingDRGByNegotiations: {
    data: [],
    loading: false,
    error: null
  },
  HospitalCountByDRGFilter: {
    reporting_entity: [],
    loading: false,
    error: null,
    state: []
  },
  HospitalCountByDRGSelected: {
    month: [],
    billing_code_type: [],
    state: [],
    provider_type: [],
    reporting_entity: [],
    data_type: [],
    loading: false,
    error: null
  },
  procedureCostByHospitalSelected: {
    codeType: [],
    city: [],
    reporting_entity: [],
    l1description: [],
    negotiatedType: [],
    billing_code_modifier: []
  },
  procedureCostByHospitaltemp: {
    codeType: [],
    city: [],
    reporting_entity: [],
    l1description: [],
    negotiatedType: [],
    billing_code_modifier: [],
    loading: false,
    error: null
  },
  procedureCostByHospitalData: {
    data: [],
    loading: false,
    error: null
  },
  drgReferenceTable: {
    data: [],
    loading: false,
    error: null
  }
};

const dataAudit = (state = initialState, action) => {
  switch (action.type) {
    /*STATIC CHART DATA REDUCERS*/
    case DATA_AUDIT_ACTIONS.REQUEST_STATIC_CHART_DATA: {
      return {
        ...state,
        staticChartData: {
          ...state.staticChartData,
          loading: true,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_STATIC_CHART_DATA: {
      return {
        ...state,
        staticChartData: {
          loading: false,
          data: action.payload,
          error: null
        }
        // allDataLoaded: !(state.staticBCBVData.loading || state.npiDistributionMap.loading)
      };
    }
    case DATA_AUDIT_ACTIONS.SET_STATIC_CHART_DATA_ERROR: {
      return {
        ...state,
        staticChartData: {
          ...state.staticChartData,
          loading: false,
          error: action.payload
        }
      };
    }

    /*DATA AUDIT TYPE REDUCER*/
    case DATA_AUDIT_ACTIONS.SET_DATA_AUDIT_TYPE: {
      return {
        ...state,
        DataAuditDataType: action.payload
      };
    }

    /*STATIC BCBV DATA REDUCERS*/
    case DATA_AUDIT_ACTIONS.REQUEST_STATIC_BCBV_DATA: {
      return {
        ...state,
        staticBCBVData: {
          ...state.staticBCBVData,
          loading: true,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_STATIC_BCBV_DATA: {
      return {
        ...state,
        staticBCBVData: {
          loading: false,
          data: action.payload,
          error: null
        }
        // allDataLoaded: !(state.staticChartData.loading || state.npiDistributionMap.loading)
      };
    }
    case DATA_AUDIT_ACTIONS.SET_STATIC_BCBV_DATA_ERROR: {
      return {
        ...state,
        staticBCBVData: {
          ...state.staticBCBVData,
          loading: false,
          error: action.payload
        }
      };
    }

    /*NPI DISTRIBUTION ACROSS COUNTRY REDUCERS*/
    case DATA_AUDIT_ACTIONS.REQUEST_NPI_DISTRIBUTION_ACROSS_COUNTRY: {
      return {
        ...state,
        npiDistributionMap: {
          ...state.npiDistributionMap,
          loading: true,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_NPI_DISTRIBUTION_ACROSS_COUNTRY: {
      return {
        ...state,
        npiDistributionMap: {
          loading: false,
          data: action.payload,
          error: null
        }
        // allDataLoaded: !(state.staticChartData.loading || state.staticBCBVData.loading)
      };
    }
    case DATA_AUDIT_ACTIONS.SET_NPI_DISTRIBUTION_ACROSS_COUNTRY_ERROR: {
      return {
        ...state,
        npiDistributionMap: {
          ...state.npiDistributionMap,
          loading: false,
          error: action.payload
        }
      };
    }

    /*DRG BY HOSPITAL WITH NTYPE REDUCERS*/
    case DATA_AUDIT_ACTIONS.REQUEST_DRG_BY_HOSPITAL_COUNT_WITH_N_TYPE: {
      return {
        ...state,
        DrgByHospitalCountWithNtype: {
          ...state.DrgByHospitalCountWithNtype,
          loading: true,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_DRG_BY_HOSPITAL_COUNT_WITH_N_TYPE: {
      return {
        ...state,
        DrgByHospitalCountWithNtype: {
          loading: false,
          data: action.payload,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_DRG_BY_HOSPITAL_COUNT_WITH_N_TYPE_ERROR: {
      return {
        ...state,
        DrgByHospitalCountWithNtype: {
          ...state.DrgByHospitalCountWithNtype,
          loading: false,
          error: action.payload
        }
      };
    }

    /*HOSPITAL COUNT DRG REDUCERS*/
    case DATA_AUDIT_ACTIONS.REQUEST_HOSPITAL_COUNT_DRG: {
      return {
        ...state,
        HospitalCountByDRG: {
          ...state.HospitalCountByDRG,
          loading: true,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_HOSPITAL_COUNT_DRG: {
      return {
        ...state,
        HospitalCountByDRG: {
          loading: false,
          data: action.payload,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_HOSPITAL_COUNT_DRG_ERROR: {
      return {
        ...state,
        HospitalCountByDRG: {
          ...state.HospitalCountByDRG,
          loading: false,
          error: action.payload
        }
      };
    }

    /*DISTING DRG BY NEGOTIATIONS REDUCERS*/
    case DATA_AUDIT_ACTIONS.REQUEST_DISTING_DRG_BY_NEGOTIATIONS: {
      return {
        ...state,
        DistingDRGByNegotiations: {
          ...state.DistingDRGByNegotiations,
          loading: true,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_DISTING_DRG_BY_NEGOTIATIONS: {
      return {
        ...state,
        DistingDRGByNegotiations: {
          loading: false,
          data: action.payload,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_DISTING_DRG_BY_NEGOTIATIONS_ERROR: {
      return {
        ...state,
        DistingDRGByNegotiations: {
          ...state.DistingDRGByNegotiations,
          loading: false,
          error: action.payload
        }
      };
    }

    /*PROVIDER DRG BY HOSPITAL REDUCERS*/
    case DATA_AUDIT_ACTIONS.REQUEST_PROVIDER_DRG_BY_HOSPITAL: {
      return {
        ...state,
        HospitalCountByDRGFilter: {
          ...state.HospitalCountByDRGFilter,
          loading: true,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_PROVIDER_DRG_BY_HOSPITAL: {
      return {
        ...state,
        HospitalCountByDRGFilter: {
          ...state.HospitalCountByDRGFilter,
          loading: false,
          provider_type: action.payload,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_PROVIDER_DRG_BY_HOSPITAL_ERROR: {
      return {
        ...state,
        HospitalCountByDRGFilter: {
          ...state.HospitalCountByDRGFilter,
          loading: false,
          error: action.payload
        }
      };
    }

    /*STATE DRG BY HOSPITAL REDUCERS*/
    case DATA_AUDIT_ACTIONS.REQUEST_STATE_DRG_BY_HOSPITAL: {
      return {
        ...state,
        HospitalCountByDRGFilter: {
          ...state.HospitalCountByDRGFilter,
          loading: true,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_STATE_DRG_BY_HOSPITAL: {
      return {
        ...state,
        HospitalCountByDRGFilter: {
          ...state.HospitalCountByDRGFilter,
          loading: false,
          state: action.payload,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_STATE_DRG_BY_HOSPITAL_ERROR: {
      return {
        ...state,
        HospitalCountByDRGFilter: {
          ...state.HospitalCountByDRGFilter,
          loading: false,
          error: action.payload
        }
      };
    }

    /*HOSPITAL COUNT BY DRG REDUCER*/
    case DATA_AUDIT_ACTIONS.REQUEST_HOSPITAL_COUNT_BY_DRG: {
      return {
        ...state,
        HospitalCountByDRGSelected: {
          ...state.HospitalCountByDRGSelected,
          provider_type: action.payload.provider_type,
          state: action.payload.state
        }
      };
    }

    /*PCH CODE TYPE REDUCERS*/
    case DATA_AUDIT_ACTIONS.REQUEST_PCH_CODE_TYPE: {
      return {
        ...state,
        procedureCostByHospitaltemp: {
          ...state.procedureCostByHospitaltemp,
          loading: true,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_REQUEST_PCH_CODE_TYPE: {
      return {
        ...state,
        procedureCostByHospitaltemp: {
          ...state.procedureCostByHospitaltemp,
          codeType: action.payload,
          error: null,
          loading: false
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_REQUEST_PCH_CODE_TYPE_ERROR: {
      return {
        ...state,
        procedureCostByHospitaltemp: {
          ...state.procedureCostByHospitaltemp,
          loading: false,
          error: action.payload
        }
      };
    }

    /*PCH NEGOTIATED TYPE REDUCERS*/
    case DATA_AUDIT_ACTIONS.REQUEST_PCH_NEGOTIATED_TYPE: {
      return {
        ...state,
        procedureCostByHospitaltemp: {
          ...state.procedureCostByHospitaltemp,
          loading: true,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_REQUEST_PCH_NEGOTIATED_TYPE: {
      return {
        ...state,
        procedureCostByHospitaltemp: {
          ...state.procedureCostByHospitaltemp,
          negotiatedType: action.payload,
          error: null,
          loading: false
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_REQUEST_PCH_NEGOTIATED_TYPE_ERROR: {
      return {
        ...state,
        procedureCostByHospitaltemp: {
          ...state.procedureCostByHospitaltemp,
          loading: false,
          error: action.payload
        }
      };
    }

    /*PCH L1 DESCRIPTION REDUCERS*/
    case DATA_AUDIT_ACTIONS.REQUEST_PCH_L1_DESCRIPTION: {
      return {
        ...state,
        procedureCostByHospitaltemp: {
          ...state.procedureCostByHospitaltemp,
          loading: true,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_REQUEST_PCH_L1_DESCRIPTION: {
      return {
        ...state,
        procedureCostByHospitaltemp: {
          ...state.procedureCostByHospitaltemp,
          l1description: action.payload,
          error: null,
          loading: false
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_REQUEST_PCH_L1_DESCRIPTION_ERROR: {
      return {
        ...state,
        procedureCostByHospitaltemp: {
          ...state.procedureCostByHospitaltemp,
          loading: false,
          error: action.payload
        }
      };
    }

    /*PCH REPORTING ENTITY REDUCERS*/
    case DATA_AUDIT_ACTIONS.REQUEST_PCH_REPORTING_ENTITY: {
      return {
        ...state,
        procedureCostByHospitaltemp: {
          ...state.procedureCostByHospitaltemp,
          loading: true,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_PCH_REPORTING_ENTITY: {
      return {
        ...state,
        procedureCostByHospitaltemp: {
          ...state.procedureCostByHospitaltemp,
          reporting_entity: action.payload,
          error: null,
          loading: false
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_PCH_REPORTING_ENTITY_ERROR: {
      return {
        ...state,
        procedureCostByHospitaltemp: {
          ...state.procedureCostByHospitaltemp,
          loading: false,
          error: action.payload
        }
      };
    }

    /*PCH CITY REDUCERS*/
    case DATA_AUDIT_ACTIONS.REQUEST_PCH_CITY: {
      return {
        ...state,
        procedureCostByHospitaltemp: {
          ...state.procedureCostByHospitaltemp,
          loading: true,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_PCH_CITY: {
      return {
        ...state,
        procedureCostByHospitaltemp: {
          ...state.procedureCostByHospitaltemp,
          city: action.payload,
          error: null,
          loading: false
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_PCH_CITY_ERROR: {
      return {
        ...state,
        procedureCostByHospitaltemp: {
          ...state.procedureCostByHospitaltemp,
          loading: false,
          error: action.payload
        }
      };
    }

    /*PCH BILLING CODE MODIFIER REDUCERS*/
    case DATA_AUDIT_ACTIONS.REQUEST_PCH_BILLING_CODE_MODIFIER: {
      return {
        ...state,
        procedureCostByHospitaltemp: {
          ...state.procedureCostByHospitaltemp,
          loading: true,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_REQUEST_PCH_BILLING_CODE_MODIFIER: {
      return {
        ...state,
        procedureCostByHospitaltemp: {
          ...state.procedureCostByHospitaltemp,
          billing_code_modifier: action.payload,
          error: null,
          loading: false
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_REQUEST_PCH_BILLING_CODE_MODIFIER_ERROR: {
      return {
        ...state,
        procedureCostByHospitaltemp: {
          ...state.procedureCostByHospitaltemp,
          loading: false,
          error: action.payload
        }
      };
    }

    /*PROCEDURE COST BY HOSPITAL REDUCERS*/
    case DATA_AUDIT_ACTIONS.REQUEST_PROCEDURE_COST_BY_HOSPITAL: {
      return {
        ...state,
        procedureCostByHospitalData: {
          ...state.procedureCostByHospitalData,
          loading: true,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_PROCEDURE_COST_BY_HOSPITAL: {
      return {
        ...state,
        procedureCostByHospitalData: {
          data: action.payload,
          error: null,
          loading: false
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_PROCEDURE_COST_BY_HOSPITAL_ERROR: {
      return {
        ...state,
        procedureCostByHospitalData: {
          ...state.procedureCostByHospitalData,
          loading: false,
          error: action.payload
        }
      };
    }

    /*RESET PCH LIST REDUCER*/
    case DATA_AUDIT_ACTIONS.RESET_PCH_LIST: {
      return {
        ...state,
        procedureCostByHospitalData: {
          ...state.procedureCostByHospitalData,
          data: []
        }
      };
    }

    /*DRG REFERENCE TABLE REDUCERS*/
    case DATA_AUDIT_ACTIONS.REQUEST_DRG_REFERENCE_TABLE: {
      return {
        ...state,
        drgReferenceTable: {
          ...state.drgReferenceTable,
          loading: true,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_DRG_REFERENCE_TABLE: {
      return {
        ...state,
        drgReferenceTable: {
          loading: false,
          data: action.payload,
          error: null
        }
      };
    }
    case DATA_AUDIT_ACTIONS.SET_DRG_REFERENCE_TABLE_ERROR: {
      return {
        ...state,
        drgReferenceTable: {
          ...state.drgReferenceTable,
          loading: false,
          error: action.payload
        }
      };
    }

    /*RESET HOSPITAL COUNT WITH NTYPE REDUCER*/
    case DATA_AUDIT_ACTIONS.RESET_HOSPITAL_COUNT_WITH_N_TYPE: {
      return {
        ...state,
        DrgByHospitalCountWithNtype: {
          ...state.DrgByHospitalCountWithNtype,
          data: []
        }
      };
    }

    /*RESET PCH FILTERS STATE REDUCER*/
    case DATA_AUDIT_ACTIONS.RESET_PCH_FILTERS_STATE: {
      return {
        ...state,
        procedureCostByHospitaltemp: action.payload
      };
    }

    default:
      return {...state};
  }
};

export default dataAudit;
